export default "__VITE_ASSET__DuNNB7x7__"